export default __webpack_public_path__ + "static/media/trusted-by-nike.081244eb.png";